import { render, staticRenderFns } from "./LeaderboardUserRenderer.vue?vue&type=template&id=0b3b8c9c&"
import script from "./LeaderboardUserRenderer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardUserRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports